import React from 'react';

export default function ProspectoConfirmModal({
  title = 'Confirmar accion',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  busy = false,
}) {
  return (
    <div className="crm-prospectos-modal-overlay" role="presentation" onMouseDown={onCancel}>
      <section className="crm-prospectos-modal is-small" role="dialog" aria-modal="true" onMouseDown={(event) => event.stopPropagation()}>
        <div className="crm-prospectos-modal-head">
          <div>
            <p className="crm-prospectos-eyebrow">Confirmacion</p>
            <h2>{title}</h2>
          </div>
          <button type="button" onClick={onCancel} disabled={busy} aria-label="Cerrar">x</button>
        </div>
        <div className="crm-prospectos-modal-body">
          <p>{message}</p>
          <div className="crm-prospectos-modal-actions">
            <button type="button" className="is-danger" onClick={onConfirm} disabled={busy}>
              {busy ? 'Procesando...' : confirmLabel}
            </button>
            <button type="button" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
          </div>
        </div>
      </section>
    </div>
  );
}
